import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { fontSize } from '../../mixins';

const StyledOptionRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  display: ${(props) => (props.swap ? 'none' : 'flex')};
  opacity: ${(props) => (props.hide ? 1 : 0.4)};

  &:not(:last-child) {
    @media screen and (max-width: 430px) {
      margin-bottom: ${({ isPromo }) => (isPromo ? '16px' : '12px')};
    }
  }
`;

const StyledImg = styled.img`
  margin-right: 16px;
  width: 53px;
  height: 53px;
`;

const StyledTitle = styled.div`
  font-weight: 700;
  ${fontSize(16)};
  line-height: 19px;
  color: #ffffff;
  margin-bottom: 2px;
`;

const StyledSubTitle = styled.span`
  font-weight: 400;
  ${fontSize(14)};
  line-height: 16px;
  color: #ffffff;
`;

const PackageOptions = ({ active, promo }) => {
  const { t } = useTranslation();
  const Options = useMemo(
    () => [
      {
        id: 0,
        src: '../assets/plan_options/CheckLocationSingleCircle.svg',
        title: `${t('check_location')}`,
        subtitle: `${t('check_location_single_subtitle')}`,
      },
      {
        id: 1,
        src: '../assets/plan_options/CheckLocationFamilyCircle.svg',
        title: `${t(promo ? 'real_time_location' : 'check_location')}`,
        subtitle: `${t(
          promo
            ? 'real_time_location_subtitle'
            : 'check_location_family_subtitle'
        )}`,
      },
      {
        id: 2,
        src: '../assets/plan_options/PlaceAlertsCircle.svg',
        title: `${t('place_alerts')}`,
        subtitle: `${t(promo ? 'screen_3_text' : 'place_alerts_subtitle')}`,
      },
      {
        id: 3,
        src: '../assets/plan_options/SpeedControlCircle.svg',
        title: `${t('speed_control')}`,
        subtitle: `${t('speed_control_subtitle')}`,
      },
      {
        id: 4,
        src: '../assets/plan_options/FallDetectionCircle.svg',
        title: `${t('fall_detection')}`,
        subtitle: `${t('fall_detection_subtitle')}`,
      },
      {
        id: 5,
        src: '../assets/plan_options/DriverProtectionCircle.svg',
        title: `${t('driver_protection')}`,
        subtitle: `${t('know_if_driving')}`,
      },
    ],
    [t, promo]
  );

  const renderOptions = (i) => (
    <React.Fragment key={i.id}>
      <StyledOptionRow
        swap={active ? i.id === 0 : i.id === 1}
        hide={active ? i.id : i.id < 2}
        isPromo={promo}
      >
        <StyledImg src={i.src} alt={i.title} />
        <div>
          <StyledTitle>{i.title}</StyledTitle>
          <StyledSubTitle>{i.subtitle}</StyledSubTitle>
        </div>
      </StyledOptionRow>
    </React.Fragment>
  );

  return Options.map(renderOptions);
};

export default PackageOptions;
